import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AppProvider, useApp } from "@/context/AppContext";
import { Toaster } from "@/components/ui/sonner";
import DashboardShell from "@/components/DashboardShell";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Onboarding from "@/pages/Onboarding";
import Overview from "@/pages/Overview";
import Opportunities from "@/pages/Opportunities";
import PagesInventory from "@/pages/PagesInventory";
import Keywords from "@/pages/Keywords";
import Locations from "@/pages/Locations";
import ContentPage from "@/pages/ContentPage";
import InternalLinks from "@/pages/InternalLinks";
import TechnicalSEO from "@/pages/TechnicalSEO";
import Analytics from "@/pages/Analytics";
import AITasks from "@/pages/AITasks";
import TaskDetail from "@/pages/TaskDetail";
import Deployments from "@/pages/Deployments";
import Connections from "@/pages/Connections";
import Billing from "@/pages/Billing";
import SettingsPage from "@/pages/SettingsPage";

const Protected = ({ children }) => {
  const { user, loading } = useApp();
  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="text-sm text-muted-foreground">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/signup" element={<AuthPage mode="signup" />} />
      <Route path="/forgot-password" element={<AuthPage mode="forgot" />} />
      <Route path="/reset-password" element={<AuthPage mode="reset" />} />
      <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
      <Route path="/dashboard" element={<Protected><DashboardShell /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="opportunities" element={<Opportunities />} />
        <Route path="pages" element={<PagesInventory />} />
        <Route path="keywords" element={<Keywords />} />
        <Route path="locations" element={<Locations />} />
        <Route path="content" element={<ContentPage />} />
        <Route path="internal-links" element={<InternalLinks />} />
        <Route path="technical" element={<TechnicalSEO />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="tasks" element={<AITasks />} />
        <Route path="tasks/:taskId" element={<TaskDetail />} />
        <Route path="deployments" element={<Deployments />} />
        <Route path="connections" element={<Connections />} />
        <Route path="billing" element={<Billing />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
